import { defineAsyncComponent } from 'vue'
import { tabOutlineListTree } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type {
  FeatureConfig,
  MainFeatureTwin,
  FeatureQueryTwin,
  FeatureParameterConfigs
} from 'src/models'
import type { QueryConfig } from 'src/composables/use-query'
import type { TreeTableColumnConfig } from 'src/components/tiles/TreeTableTile'
import type { QUERY_KIND } from 'src/services/constants'

export interface TreeTableFeatureTwin extends MainFeatureTwin, QueryConfig {
  /** The $dtId of the twin the browser starts from (defaults to 'root'). */
  graphRootId?: string
  /** ADT query loading the children of an expanded row (`@_treeParent` is bound per row). */
  childQuery?: string
  /** JEXL expression deciding whether a row can be expanded (context: {row, level, params}). */
  hasChildrenExpression?: string
  /** Maximum depth that can be expanded (0 = root rows only, undefined = unlimited). */
  maxDepth?: number
  queryKind?: QUERY_KIND
  query?: string
  parameters?: FeatureParameterConfigs
  /** Automatically sync selected twins to the store when selection changes */
  syncSelection?: boolean
  /** Always fetch selected twins from API even if already in the store */
  syncSelectionOverwrite?: boolean
}

/** dtmi:com:arcadis:app:TreeTableQuery;1 */
export interface TreeTableQueryTwin extends FeatureQueryTwin, QueryConfig {
  twinColumn?: string
  columns?: { [columnKey: string]: TreeTableColumnConfig } | TreeTableColumnConfig[]
  itemLabel?: string
  itemColor?: string
  itemIcon?: string
  defaultSortColumn?: string
  defaultSortDesc?: boolean
  defaultExpandLevel?: number
  showExpandAll?: boolean
  showColumnSelection?: boolean
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./TreeTableFeatureMain.vue')),
    splitter: 900,
    icon: tabOutlineListTree,
    label: 'Tree table'
  }
}

export default featureConfig
